<template>
    <div v-bind:id="source.id" class="discuss-chat-panel dsp-flex">
        <!-- 他人头像 -->
        <div v-if="source.type != CONST_DISCUSS_MSG_TYPE.recall && source.type != CONST_DISCUSS_MSG_TYPE.like && source.uid != curUserUid" class="discuss-cal-alpha-box discuss-cal-other" @click="clickAlpha">
            <div v-if="source.vip != 0" class="vip-bd"></div>
            <div v-if="source.vip != 0" class="vip-crown"></div>
            <div class="discuss-chat-alpha-box">
                <keep-alive><img class="discuss-chat-alpha" :src="source.avatarUrl" alt=""></keep-alive>
            </div>
        </div>
        <!-- 类型:除了'撤回'以外的所有类型 -->
        <div v-if="source.type != CONST_DISCUSS_MSG_TYPE.recall && source.type != CONST_DISCUSS_MSG_TYPE.like" class="discuss-chat-content" v-bind:class="{'discuss-cc-left': source.uid == curUserUid, 'discuss-cc-right': source.uid != curUserUid}" v-longpress="longPressContent">
            <!-- 他人:昵称 -->
            <div v-if="source.uid != curUserUid" class="discuss-chat-nickname">
                <span class="nickname" :class="{'nickname-red': source.vip != 0}">{{source.nickname}}</span>
                <span v-if="source.uid == lunpanData.uid" class="author">案主</span>
                <span v-if="source.donate == 1" class="donate"></span>
            </div>
            <!-- 他人:聊天文本 -->
            <div v-if="source.uid != curUserUid" class="discuss-chat-text-box">
                <div v-bind:ref="source.id" class="discuss-chat-text discuss-chat-text-other" @click="clickText">
                    <p v-html="UTILS.getDiscussContentYear(UTILS.getBreakLineByText(source.content))"></p>
                </div>
                <div v-if="source.likeNum && source.likeNum != 0" class="discuss-chat-like discuss-chat-like-other">
                    <i class="iconfont icon-like"></i><span class="like-num">{{source.likeNum}}</span>
                </div>
            </div>
            <!-- 他人:聊天引用的文本 -->
            <div v-if="source.uid != curUserUid && source.type == CONST_DISCUSS_MSG_TYPE.reply && source.quoteCont" class="discuss-chat-text-quote discuss-chat-text-quote-other">
                <p>{{source.quoteCont}}</p>
            </div>
            <!-- 我的:聊天文本 -->
            <div v-if="source.uid == curUserUid" class="discuss-chat-text-box clearfix">
                <!-- 我的昵称 -->
                <div class="discuss-chat-nickname discuss-chat-nickname-my">
                    <span v-if="source.donate == 1" class="donate"></span>
                    <span v-if="source.uid == lunpanData.uid" class="author">案主</span>
                    <span class="nickname" :class="{'nickname-red': source.vip != 0}">{{source.nickname}}</span>
                </div>
                <div v-bind:ref="source.id" class="discuss-chat-text discuss-chat-text-my" @click="clickText">
                    <p v-html="UTILS.getDiscussContentYear(UTILS.getBreakLineByText(source.content))"></p>
                </div>
                <div v-if="source.likeNum && source.likeNum != 0" class="discuss-chat-like discuss-chat-like-my">
                    <i class="iconfont icon-like"></i><span class="like-num">{{source.likeNum}}</span>
                </div>
            </div>
            <!-- 我的:聊天引用的文本 -->
            <div v-if="source.uid == curUserUid && source.type == CONST_DISCUSS_MSG_TYPE.reply && source.quoteCont" class="discuss-chat-text-quote-box clearfix">
                <div class="discuss-chat-text-quote discuss-chat-text-quote-my">
                    <p>{{source.quoteCont}}</p>
                </div>
            </div>
            <img v-if="source.type == CONST_DISCUSS_MSG_TYPE.image" class="discuss-chat-img" v-bind:class="{'discuss-chat-img-my': source.uid == curUserUid, 'discuss-chat-img-other': source.uid != curUserUid}" :src="source.content" alt="">
        </div>
        <!-- 类型:撤回消息 -->
        <div v-if="source.type == CONST_DISCUSS_MSG_TYPE.recall" class="discuss-chat-content discuss-chat-content-recall">
            <p v-if="source.isdel">{{(source.uid == curUserUid ? '你' : '"'+source.nickname+'"')+source.content}}</p>
            <p v-else>{{source.content}}</p>
        </div>
        <!-- 类型:点赞消息 -->
        <div v-if="source.type == CONST_DISCUSS_MSG_TYPE.like" class="discuss-chat-content discuss-chat-content-like">
            <p>{{source.content ? source.content : (source.uid == curUserUid ? '我赞了“'+source.quoteName+'”' : source.nickname+'赞了“'+source.quoteName+'”')}}</p>
            <div class="discuss-chat-sub-content-like">
                <p>{{source.quoteCont}}</p>
            </div>
        </div>
        <!-- 我的头像 -->
        <div v-if="source.type != CONST_DISCUSS_MSG_TYPE.recall && source.type != CONST_DISCUSS_MSG_TYPE.like && source.uid == curUserUid" class="discuss-cal-alpha-box"  @click="clickAlpha">
            <div v-if="source.vip != 0" class="vip-bd"></div>
            <div v-if="source.vip != 0" class="vip-crown"></div>
            <div class="discuss-chat-alpha-box">
                <keep-alive><img class="discuss-chat-alpha" :src="source.avatarUrl" alt=""></keep-alive>
            </div>
        </div>

        <!-- 6、操作气泡 -->
        <div ref="bubble" v-if="showBubble" class="discuss-cal-bubble">
            <i class="discuss-calb-arrow"></i>
            <div class="discuss-calb-list dsp-flex">
                <div class="discuss-calb-item" @click="clickCopy">
                    <p><i class="iconfont icon-copy"></i></p>
                    <p>复制</p>
                </div>
                <div v-if="source.uid != curUserUid" class="discuss-calb-item" @click="clickReply">
                    <p><i class="iconfont icon-reply"></i></p>
                    <p>回复</p>
                </div>
                <div v-if="source.uid != curUserUid" class="discuss-calb-item" @click="clickLike">
                    <p><i class="iconfont icon-like"></i></p>
                    <p>点赞</p>
                </div>
                <div v-if="source.uid == curUserUid && showRecall" class="discuss-calb-item" @click="clickRecall">
                    <p><i class="iconfont icon-recall"></i></p>
                    <p>撤回</p>
                </div>
                <div v-if="source.uid == curUserUid" class="discuss-calb-item" @click="clickReply">
                    <p><i class="iconfont icon-quote"></i></p>
                    <p>引用</p>
                </div>
            </div>
        </div>

        <div v-if="showAvatarPop" class="discuss-avatar-pop">
            <div class="discuss-avatar-pp-title">该用户是{{source.vip == 0 ? '普通会员' : source.vip == 10 ? '月会员' : source.vip == 20 ? '年会员' : source.vip == 30 ? '终身会员' : ''}}</div>
            <div class="discuss-avatar-pp-sub-title">用户ID：{{source.uid}}</div>
            <div class="discuss-avatar-pp-btn" @click="clickAvatarBtn">享有TA的特权</div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
import { CONST_DISCUSS_MSG_TYPE } from '../../modules/data/base/consts';
export default {
    name: 'DiscussItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        }
    },
    computed: {
        curUserUid() {
            return this.$store.state.discuss.curUserUid;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanHistoryList() {
            return this.$store.state.discuss.lunpanHistoryList;
        },
        lunpanRoomSelectedUserData() {
            return this.$store.state.discuss.lunpanRoomSelectedUserData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            CONST_DISCUSS_MSG_TYPE: CONST_DISCUSS_MSG_TYPE,
            showBubble: false,
            showRecall: false,
            showAvatarPop: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            // console.error('discussitem------', me.source.vip)
            me.initFunc();
        }, 1000);
        this.$bus.on('hideDiscussBubble', this.hideBubble);
        this.$bus.on('hideDiscussAvatarPop', this.hideAvatarPop);
    },
    destroyed() {
        this.$bus.off('hideDiscussBubble', this.hideBubble);
        this.$bus.off('hideDiscussAvatarPop', this.hideAvatarPop);
    },
    methods: {
        initFunc() {
            var me = this;
            window.clickNum = function(num) {
                var name = 'liunian'+num;
                // console.error('clickNum------num-----', name)
                me.$store.dispatch('minifatefortune/triggerFortuneItemFunction', name);
            }
        },
        clickAvatar() {
            // console.error('clickAvatar-----', this.source)
            this.$bus.emit('updateDiscussAtAvatarText', this.source)
        },
        clickAlpha() {
            if(this.source.uid != this.curUserUid) {
                // 点击他人头像
                // let itemHeight = this.parentNode;
                console.log('clickAlpha------Other', this.source)
                this.$bus.emit('showDiscussAvatarOverlay');
                this.showAvatarPop = true;
            }else {
                // 点击自己头像
                console.log('clickAlpha------My', this.source);
                this.$store.dispatch('user/showMyVipPop', {vip: this.source.vip, frompage: 'discuss_avt'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
            }
        },
        hideAvatarPop() {
            this.showAvatarPop = false;
        },
        clickAvatarBtn() {
            this.showAvatarPop = false;
            this.$bus.emit('hideDiscussAvatarOverlay');

            let userVip = this.$store.state.userData.vip;
            this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'discuss_avt'});
            setTimeout(() => {
                this.$bus.emit('initMyVipPage');
            }, 20);

        },
        longPressContent() {
            // 先隐藏掉原来的
            this.$bus.emit('hideDiscussBubble');

            var me = this,
                cBox = this.$refs[this.source.id],
                cW = cBox ? cBox.clientWidth : 200, 
                cH = this.$el.clientHeight;
            // console.error('longPressContent------', this.source)
            var diffM = UTILS.checkTimeDiffMinuteToNow(this.source.time);
            this.showRecall = diffM <= 5 ? true : false;
            this.showBubble = true;

            // 处理高度
            // var topDiv = document.getElementsByClassName('discuss-fate-topbar')[0],
            //     bottomDiv = document.getElementsByClassName('discuss-bottom-bar-box')[0],
            //     diffH = topDiv ? innerHeight-topDiv.clientHeight : innerHeight;
            //     diffH = bottomDiv ? diffH-bottomDiv.clientHeight : diffH;
            // console.error('longpresscontent-------', cH, diffH)
            // cH = cH > diffH ? cH/2 : cH;
            // var listDom = document.getElementsByClassName('discuss-history-list')[0],
            //     lH = listDom.clientHeight - listDom.style.paddingTop;
            setTimeout(() => {
                // 动态设置气泡的位置
                var cLeft = 0, cTop = 0, bW = me.$refs.bubble ? me.$refs.bubble.clientWidth : 200;
                if(me.source.uid == me.curUserUid) {
                    cLeft = cW >= bW ? innerWidth-(cW+75)+(cW/2-bW/2) : innerWidth-(cW+75)-(bW/2-cW/2);
                    cLeft = cLeft >= innerWidth-bW-25 ? innerWidth-bW-25 : cLeft;
                    cTop = cH;
                }else {
                    cLeft = 50+(cW/2-bW/2);
                    cLeft = cLeft < 0 ? 0 : cLeft;
                    cTop = cH-20;
                }
                // console.log('------', innerWidth, cW, bW, cLeft)
                if(me.$refs.bubble) {
                    me.$refs.bubble.style.left = cLeft+'px';
                    me.$refs.bubble.style.bottom = cTop+'px';
                }
            }, 10);
            this.$bus.emit('showDiscussBlankOverlay');
        },
        hideBubble() {
            this.showBubble = false;
            this.$bus.emit('hideDiscussBlankOverlay');
        },
        clickText() {
            // 八字类型的数据
            if(this.source.type == CONST_DISCUSS_MSG_TYPE.birth) {
                this.$store.state.discuss.showDiscussDownloadPop = true;
            }
        },
        clickCopy() {
            var me = this;
            UTILS.copyTextToClipboard(this.source.content, function() {
                me.$toast('复制消息成功');
                me.hideBubble();
            });
        },
        clickReply() {
            this.$store.state.discuss.curDiscussQuoteData = this.source;
            this.hideBubble();
            this.$bus.emit('triggerDiscussFocused');
        },
        clickLike() {
            var curIndex = _.findIndex(this.lunpanHistoryList, data=>{return data.id == this.source.id});
            console.log('clickLike--------', curIndex, this.source)
            this.$store.dispatch('discuss/likeWSMessage', {
                uid: this.source.uid,
                msg_type: CONST_DISCUSS_MSG_TYPE.like,
                content: this.source.id,
                index: curIndex
            });
            // 操作完成之后,隐藏气泡
            this.hideBubble();
        },
        clickRecall() {
            var curIndex = _.findIndex(this.lunpanHistoryList, data=>{return data.id == this.source.id});
            console.log('clickRecall--------', curIndex, this.source)
            this.$store.dispatch('discuss/recallMyWSMessage', {
                uid: this.curUserUid,
                msg_type: CONST_DISCUSS_MSG_TYPE.recall,
                content: this.source.id,
                index: curIndex
            });
            // 操作完成之后,隐藏气泡
            this.hideBubble();
        }
    }
}
</script>